var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full",attrs:{"id":"app"}},[_c('Loader',{attrs:{"loading":true,"fullscreen":"","target":"body","lock":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }